import React from 'react'
import Tray from '~/modules/Tray/Video'
import Spinner from '~/components/Spinner'
import lazyLoad from "~/tools/lazy-load-images";
import { PLURAL_CONTENT_TYPE_OUTPUTS, contentTypes } from '~/redux/websearch/constant'
import {getResults, getLayout} from '~/redux/websearch/helper'
import { trackEvent } from "~/tools/analytics/cleverTap";
import { trackPageview } from "~/tools/analytics/googleAnalytics"
import ErrorBoundary from '~/components/ErrorBoundary'
import {get, map, isEmpty, debounce} from 'lodash'
import './style.css'
import Cookies from "js-cookie"
import { getLocalizedVal } from '~/tools/localization/helpers';


class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      searchResults: {},
      settings: {},
      contentTypes: contentTypes
    };
  }

  componentDidMount() {
    this.searchInput.focus();

    getLayout("Search Screen").then(({ moduleList }) => {
      this.setState({ settings: moduleList[0].settings });
    });
  }

  getLocalizedVal(path) {
    const messages = window.settings.genericMessages;
    var chosenLangCode = Cookies.get('userLanguageSelection');
    if(chosenLangCode === "") {
      chosenLangCode = window.settings.languages.default.code
    }
    const localizedVal = get(messages, `localizationMap.${chosenLangCode}.${path}`)
    const defaultVal = get(messages, path)
    return localizedVal || defaultVal
  }

  componentDidUpdate() {
    if (!this.state.loading && this.state.searchTerm.length > 0) {
      var searchEventData = {
        keyword: this.state.searchTerm,
        platform: 'Web'
      }
      trackEvent('Searched', searchEventData);
      trackPageview(
        `/search?searchTerm=${this.state.searchTerm}`
      );
    }
    setTimeout(lazyLoad, 1000);
  }

  render() {
    const hasResults = this.state.totalResults > 0;
    return (
      <div className="search">
        <div
          className={"search-container " + (hasResults ? "has-results" : "")}
        >
          <span className="title">{this.getLocalizedVal('searchHeaderLabel')}</span>
          <div className="search-input">
            <input
              type="text"
              className="search-container-input"
              placeholder={this.getLocalizedVal('searchHeaderLabel')+"..."}
              ref={input => {
                this.searchInput = input;
              }}
              onChange={debounce(e => this.handleKeyUp(e), 1000)}
            />
          </div>
        </div>
        {this.state.loading && <Spinner />}
        {!this.state.loading &&
          this.state.searchTerm.length > 0 && (
            <div className="search-results">
              {hasResults ? (
                this.renderResults()
              ) : (
                <div className="no-results">{this.getLocalizedVal('noResult')}</div>
              )}
            </div>
          )}
        <div className={this.getSearchResultsClassNames()}>
          {this.renderMobileResults()}
        </div>
      </div>
    );
  }

  getSearchResultsClassNames() {
    return !isEmpty(this.state.searchResults)
      ? "search-results search-results-mobile results"
      : "search-results search-results-mobile";
  }

  renderResults = () =>  {
    return map(
      this.state.searchResults,
      (contentResults, contentType) =>
        contentResults.length > 0 && (
          <ErrorBoundary>
            <Tray
              key={contentType}
              trayTitle='Search Results'
              data={{
                contentData: contentResults,
                title: this.getLocalizedTrayHeader(PLURAL_CONTENT_TYPE_OUTPUTS[contentType]),
                filters: {}
              }}
              layout={{ settings: this.state.settings }}
            />
          </ErrorBoundary>
        )
    );
  }

  getLocalizedTrayHeader = (trayHeaderKey) => {
    let title = trayHeaderKey && trayHeaderKey.replace(/\s+/g, "").toLowerCase();
    return getLocalizedVal(window.settings,'genericMessages', `${title}TrayHeader`) || trayHeaderKey
  }

  renderMobileResults() {
    return map(this.state.searchResults, (items, category) => {
      return (
        items.length > 0 &&
        map(
          items,
          item =>
            item.contentType === "PERSON"
              ? this.renderMobileTypeahead(item)
              : this.renderMobileTypeahead(item.gist)
        )
      );
    });
  }

  renderMobileTypeahead(item) {
    return (
      item && (
        <a
          href={item.permalink}
          className={
            `search-item ` + (item.contentType === "VIDEO" ? "video-item" : "")
          }
          key={item.id}
        >
          <div className="content-type">
            {PLURAL_CONTENT_TYPE_OUTPUTS[item.contentType]}
          </div>
          <div className="title">
            {item.title || `${item.firstName} ${item.lastName}`}
          </div>
          {item.contentType === "VIDEO" && (
            <div className="duration">
              {this.renderDuration(item) + " | " + this.renderYear(item)}
            </div>
          )}
        </a>
      )
    );
  }

  renderDuration(item) {
    const runtime = Math.ceil(item.runtime / 60);
    return `${runtime} min${runtime > 1 ? "s" : ""}`;
  }

  renderYear(item) {
    return new Date(item.addedDate).getFullYear();
  }

  handleKeyUp(event) {
    let searchTerm = this.searchInput.value;
    let searchResults = {};
    let totalResults = 0;
    this.setState({ loading: !!searchTerm && searchTerm.length > 0 });
    this.state.contentTypes.forEach(contentType => {
      getResults(searchTerm, contentType).then(r => {
        if (r) {
          searchResults[`${contentType}`] = r.data;
          totalResults += r.data.length;
        }
        if (Object.keys(searchResults).length === 7) {
          this.setState({
            loading: false,
            searchResults: searchResults,
            searchTerm: searchTerm,
            totalResults: totalResults
          });
        }
      });
    });
  }
}

export default Search
